import { createDynamicThunk } from ".";

export const getLocationListThunk = createDynamicThunk({
  typePrefix: "locations/getLocationListThunk",
  useHandleSearch: true,
});

export const addLocationThunk = createDynamicThunk({
  typePrefix: "locations/addLocationThunk",
  endpoint: "/locations",
  method: "POST",
  refreshList: true,
  listThunk: getLocationListThunk,
});

export const editLocationThunk = createDynamicThunk({
  typePrefix: "locations/editLocationThunk",
  endpoint: "/locations",
  method: "PUT",
  refreshList: true,
  listThunk: getLocationListThunk,
  transformResponse: (response) => response,
});

export const deleteLocationThunk = createDynamicThunk({
  typePrefix: "/deleteLocationThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getLocationListThunk,
});
